@if (formGroup) {
  <app-checkbox-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
  ></app-checkbox-control>
}
